// Static step chrome for the Setup Progress wizard bar. Keep in sync with the step keys/order
// used by App\Services\GameSetupProgressService on the backend (Game Home feature).
const SETUP_PROGRESS_STEPS = [
  {
    key: 'about_game',
    order: 1,
    label: 'About Game',
    subLabel: 'Basic details',
    route: '/game-setup',
  },
  {
    key: 'game_structure',
    order: 2,
    label: 'Game Structure',
    subLabel: 'Game rules',
    route: '/game-structure',
  },
  { key: 'rounds', order: 3, label: 'Rounds', subLabel: 'Dates & windows', route: '/rounds' },
  {
    key: 'competitions',
    order: 4,
    label: 'Competitions',
    subLabel: 'Grades / Divisions',
    route: '/comps',
  },
  { key: 'teams', order: 5, label: 'Teams', subLabel: 'Add your teams', route: '/teams' },
  {
    key: 'fixtures',
    order: 6,
    label: 'Fixtures',
    subLabel: 'Schedule matches',
    route: '/create-fixtures',
  },
  {
    key: 'point_system',
    order: 7,
    label: 'Point System',
    subLabel: 'Import or add',
    route: '/point-system',
  },
  {
    key: 'game_entry',
    order: 8,
    label: 'Game Entry',
    subLabel: 'Access & joining',
    route: '/game-entry',
  },
  {
    key: 'pricing_plan',
    order: 9,
    label: 'Pricing Plan',
    subLabel: 'Choose your plan',
    route: '/pricing-plan',
  },
]

export default SETUP_PROGRESS_STEPS
